import { type NFTFormattedCollectibleDTO } from '@capsicum/common';
import { usePartners } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { useMyCollectibleQuery } from '../data-access/queries';
import { type MyCollectible } from '../models';
import { mapPartnerToCollectiblePartner } from '../util';

/**
 * @param collectibleId
 * @returns single collectible owned by user
 */
export const useMyCollectible = (collectibleId: string) => {
	const { getPartnerBy } = usePartners();

	return useMyCollectibleQuery(
		collectibleId,
		useCallback(
			(data: NFTFormattedCollectibleDTO | undefined): MyCollectible | undefined => {
				const partner = getPartnerBy(p => p.id === data?.summary?.references?.partnerId);

				return {
					...data,
					partner: mapPartnerToCollectiblePartner(partner)
				};
			},
			[getPartnerBy]
		),
		{
			enabled: !!collectibleId
		}
	);
};
